/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Custom_DescriptionInputs */

const en_admin_settings_custom_description = /** @type {(inputs: Admin_Settings_Custom_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add your own key/value configs. Keys must be unique and not collide with built-in settings.`)
};

const zh_admin_settings_custom_description = /** @type {(inputs: Admin_Settings_Custom_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加自定义的 key/value 配置。Key 必须唯一，且不能与内置配置项重名。`)
};

/**
* | output |
* | --- |
* | "Add your own key/value configs. Keys must be unique and not collide with built-in settings." |
*
* @param {Admin_Settings_Custom_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_custom_description = /** @type {((inputs?: Admin_Settings_Custom_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Custom_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_custom_description(inputs)
	return zh_admin_settings_custom_description(inputs)
});
export { admin_settings_custom_description as "admin.settings.custom.description" }